import { render, staticRenderFns } from "./MainLifeRiderWidget.vue?vue&type=template&id=bbe8e3d0&scoped=true"
import script from "./MainLifeRiderWidget.vue?vue&type=script&lang=js"
export * from "./MainLifeRiderWidget.vue?vue&type=script&lang=js"
import style0 from "./MainLifeRiderWidget.vue?vue&type=style&index=0&id=bbe8e3d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe8e3d0",
  null
  
)

export default component.exports